import React from 'react'
import imgOne from '../../assets/landing/token_roadmap-1.svg'
import imgTwo from '../../assets/landing/token_roadmap-2.svg'
import imgThree from '../../assets/landing/token_roadmap-3.svg'
import imgStoneTop from '../../assets/landing/shape_stone_1.svg'
import imgTreeTop from '../../assets/landing/shape_tree_1_1.png'
import imgStoneBottom from '../../assets/landing/token_bottom_stone_frog.svg'
import imgTreeBottom from '../../assets/landing/token_tree_bottom.png'

const itemsData = [
  {
    id: '📍 Phase 1',
    title: 'PREGNANCY',
    image: imgOne,
    bg: '#FEF537',
    border: '#D1C705',
    features: [
      '📅 “Cooking in the cryptowomb!',
      '👩‍🍼 Mumma Pepe got a baby on the way!',
      '🚀 Launch Presale Incoming',
      '🤝 Big Name Partnerships',
      '💬 Community Hype = Max Vibes',
      '📢 "Wen birth?"'
    ]
  },
  {
    id: '📍 Phase 2',
    title: 'BIRTH',
    image: imgTwo,
    bg: '#E7FF53',
    border: '#CAE909',
    features: [
      '👶 It’s a boy! And he’s moon-ready!',
      '📈 Listed on Top Exchanges & Uniswap',
      '🔥 1 BILLION MCAP or bust',
      '💣 Massive Marketing Blitz',
      '📢 "LILPEPE GO BRRRRR'
    ]
  },
  {
    id: '📍 Phase 3',
    title: 'GROWTH',
    image: imgThree,
    bg: '#C8F2FF',
    border: '#89E3FF',
    features: [
      '🧠 From baby meme to blockchain beast',
      '⚡️ Ultra-fast. 🛡️ Secure. 💸 Cheap.',
      '🧱 Layer 2 EVM — Built different',
      '👑 Little Pepe becomes the KING',
      '📈 Hits TOP 100 CMC',
      '📢 All hail the LILPEPE chain!'
    ]
  }
]
const TokenRoadmap = () => {
  return (
    <div className="bg-[#006C28] relative py-20" id="roadmap">
      <img
        src={imgStoneTop}
        alt=""
        className="absolute top-[-20px] md:top-[-50px] xl:top-[-80px] w-full"
      />
      <img
        src={imgTreeTop}
        alt=""
        className="absolute top-[-20px] left-[-10px] md:top-[-70px]  w-[240px] h-[165px] md:w-auto md:h-auto"
      />
      <img
        src={imgStoneBottom}
        alt=""
        className="absolute bottom-[-20px] md:bottom-[-100px] xl:bottom-[-100px] z-30 w-full"
      />
      <img
        src={imgTreeBottom}
        alt=""
        className="absolute right-0 bottom-[0] md:bottom-[-50px] w-[400px] z-10"
      />
      <div className="flex items-center justify-center">
        <h2 className="text-[#FEF537] text-[50px] md:text-[99px] font-extrabold max-w-[350px] md:max-w-full text-center py-6 font-sourGummy xl:pt-[100px]">
          Our Token Roadmap
        </h2>
      </div>
      <div className="flex flex-col gap-12 pt-8 pb-20">
        {itemsData.map(item => (
          <div
            key={item.id}
            className="flex flex-col md:flex-row items-center justify-between max-w-[1080px] w-[75%] mr-[30px] md:mr-auto md:w-full mx-auto px-6 py-6 rounded-xl relative"
            style={{
              background: `${item.bg}`,
              border: `3px dashed ${item.border}`,
              zIndex: '20'
            }}
          >
            <div className="absolute left-[-60px] md:left-[-80px] top-0">
              <div
                className="size-[36px] flex items-center justify-center rounded-full"
                style={{
                  border: `2px solid ${item.bg}`
                }}
              >
                <div
                  className={`size-[20px] rounded-full`}
                  style={{
                    background: `${item.bg}`
                  }}
                ></div>
              </div>
              <div
                className="absolute top-[36px] left-[17px] w-[3px] h-[580px] md:h-[400px] "
                style={{ background: `${item.bg}` }}
              ></div>
            </div>
            <div className="w-full">
              <h5 className="text-[18px] font-sourGummy font-bold">
                {item.id}
              </h5>
              <h2 className="border-b border-black pb-1 text-[42px] font-bold font-sourGummy w-full">
                {item.title}
              </h2>
              <div className="flex flex-wrap gap-4 max-w-[600px] w-full pt-4">
                {item.features.map((feat, featIndex) => (
                  <div key={featIndex} className="text-[14px] font-sourGummy">
                    {feat}
                  </div>
                ))}
              </div>
            </div>
            <div>
              <img
                src={item.image}
                alt=""
                className="max-w-[228px] h-[156px] md:max-w-[400px] md:h-[250px] w-auto"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TokenRoadmap
